import type { AreaData } from "./types.js";
import { decodeUkCoastline } from "./uk-coastline.js";

/**
 * UK-wide low-detail backdrop. Provides a sensible chart for any
 * scenario authored outside the high-detail teaching areas (Solent,
 * Weymouth/Portland, Moray Firth, Plockton). Coastline is decoded
 * lazily from the flat-encoded UK_COASTLINE_FLAT so the bundle pays
 * the cost only on first access.
 *
 * Marks, lanes, and ferry templates intentionally start empty — this
 * area is the "anywhere else in UK waters" fallback. Authors can
 * either prefer one of the dedicated areas, or add scenario-local
 * marks via vessel definitions.
 */

export const UK_GENERAL: AreaData = {
  area: "uk-general",
  // Wide bbox covering Lands End, Dover, north to Shetland.
  boundingBox: {
    nw: { lat: 60.9, lon: -8.7 },
    se: { lat: 49.5, lon: 2.0 },
  },
  // Decoded once on first read; subsequent reads return the cached
  // array. AreaData is a frozen module-level constant, so a getter
  // here is the lightest-touch way to defer the decode without
  // changing the AreaData contract.
  get coastline() {
    return decodeUkCoastline();
  },
  depthContours: [],
  marks: [],
  lanes: new Map(),
  raconIds: new Set(),
  ferryTemplates: [],
};
